import { Link, Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';

function ContactRoute() {
  return (
    <ContainerLayout>
      <Typography level="h1">Kontakt</Typography>
      <br />
      <Typography>
        Das Digitale Verkehrszeichenkataster Baden-Württemberg befindet sich in einer Pilotphase. Das bedeutet, dass
        manchmal Fehler auftreten könnten oder nicht das gewünschte Ergebnis dargestellt wird. Die Datengrundlage wird
        sich in den kommenden Monaten laufend verbessern. Das Digitale Verkehrszeichenkataster Baden-Württemberg wird
        derzeit um weitere Funktionen erweitert. Sie können die Anwendung jedoch bereits jetzt gerne nutzen.
      </Typography>
      <br />
      <Typography>
        Bei Fragen oder Hinweisen wenden Sie sich gerne an{' '}
        <Link href="mailto:verkehrszeichenkataster@vm.bwl.de">verkehrszeichenkataster@vm.bwl.de</Link>
      </Typography>
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/kontakt')({
  component: ContactRoute,
});
